import { gql } from '@ori/fetching';

export const labels = gql`
  fragment ProductLabels on ProductLabel {
    labelKey
    productLabelDomain
    title
  }
`;
